import Box from "@mui/material/Box";
import { Chip, Stack, Typography } from "@mui/material";
import { SVariantDto } from "@/__generated__/sdk";
type Props = {
  variant?: SVariantDto | null;
};
export default function VariantPrice({ variant }: Props) {
  return (
    <>
      <Box
        sx={{
          width: "100%",
          position: "sticky",
          bottom: "48px",
          left: 0,
          right: 0,
        }}
      >
        {variant ? (
          <Stack direction={"row"} alignItems={"start"} justifyContent={"start"}>
            {variant.offer ? (
              <Stack alignItems={"start"}>
                <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} spacing={1}>
                  <Typography variant="subtitle1" color={"grey.600"} component={"s"}>
                    {variant.price.toLocaleString()} تومان
                  </Typography>
                  <Box
                    sx={{
                      backgroundColor: "error.100",
                      borderRadius: 4,
                      height: 24,

                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography color={"white.main"} sx={{ mx: 1 }} variant="body1" lineHeight={0}>
                      % {variant.offer.percentage}
                    </Typography>
                  </Box>
                </Stack>
                <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} spacing={1}>
                  <Typography variant="h4">{variant.offer.price.toLocaleString()} </Typography>
                  <Typography variant="h4" color={"grey.500"}>
                    تومان
                  </Typography>
                </Stack>
              </Stack>
            ) : (
              <Stack>
                <Box sx={{ height: { xs: 5, md: 28 } }}></Box>

                <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} spacing={1}>
                  <Typography variant="h4" component={"div"}>
                    {variant.price.toLocaleString()}
                  </Typography>
                  <Typography variant="h4" component={"div"} color={"grey.500"}>
                    تومان
                  </Typography>
                </Stack>
              </Stack>
            )}
          </Stack>
        ) : (
          <Chip
            sx={{ backgroundColor: "grey.100" }}
            label={
              <Typography variant="body2" color={"grey.500"}>
                ناموجود
              </Typography>
            }
          />
        )}
      </Box>
    </>
  );
}
